module.exports = __webpack_public_path__ + "img/aai-MAT-sample-result-chart.fe97e4c1.png";